const ATTA_REPORT = Object.create(null);
const ATTA_EVENT_RESULT = {
  SUCCESS: 0,
  FAIL: -1,
};

ATTA_REPORT.MOBILE_INPUT = {
  SHOW: 'act_mobileinput_show',
  INPUT_FINISH: 'act_mobileinput_finish',
  CLICK: 'act_mobileinputbutton_click',
};

ATTA_REPORT.ORDER = {
  ORDER_CLICK: 'act_orderbtn_click',
  INPUT_FINISH: 'act_telinput_finish',
  INPUT_FINISH_POP: 'act_telinputpop_finish',
};

ATTA_REPORT.RECEIVE_PRIZE = {
  GIFT: 'act_giftbtn_click',
  LOTTERY: 'act_lotbtn_click',
};

ATTA_REPORT.PACKAGE_LIST = {
  RESULT: 'act_packagelist_req',
};

ATTA_REPORT.ORDER_PACKAGE = {
  RESULT: 'act_orderpackage_req',
};

ATTA_REPORT.RECEIVE_PRIZE_RESULT = {
  GIFT: 'act_gifreq_req',
  LOTTERY: 'act_lotgift_req',
  NORMAL: 'act_normgiftreq_req',
  RIGHT: 'act_benefitgift_req',
};

ATTA_REPORT.LOTTERY_PRIZE = {
  LOTTERY: 'act_lotreq_req',
  RIGHT: 'act_benefitreq_req',
};

ATTA_REPORT.VERIFY = {
  VIEW: 'verify_view_view',
  SUBMIT: 'verify_submit_req',
  CODEGET_AUTOREQ: 'verify_codeget_autoreq',
  CODEGET_CLICK: 'verify_codeget_click',
  // region 移动的二次确认和关闭
  CANCEL_CLICK: 'verify_cancel_click',
  CONFIRM_CLICK: 'verify_confirm_click',
  // endregion
  // region 翼支付样式3弹窗协议合规埋点（dxyzf）EVT-20 ~ EVT-29
  /** EVT-20 协议勾选区曝光 — 公共参数：packageId / captchaModalType=`dxyzf` / agreementVersion / defaultChecked */
  AGREEMENT_VIEW: 'verify_agreement_view',
  /** EVT-21 用户勾选协议 — 公共参数 + from（`checkbox` / `text`） */
  AGREEMENT_CHECK: 'verify_agreement_check',
  /** EVT-22 用户取消勾选协议 — 公共参数 */
  AGREEMENT_UNCHECK: 'verify_agreement_uncheck',
  /** EVT-23 协议超链接点击 — 公共参数 + agreementId / kind（`inline`/`external`/`invalid`） */
  AGREEMENT_LINK_CLICK: 'verify_agreement_link_click',
  /** EVT-24 协议配置降级 — 公共参数（agreementVersion 可空）+ errorType（`configMissing`/`parseFail`/`versionMissing`/`modalTypeMismatch`） */
  AGREEMENT_CONFIG_FALLBACK: 'verify_agreement_config_fallback',
  /** EVT-25 协议文本弹窗曝光 — 公共参数 + agreementId */
  AGREEMENT_MODAL_VIEW: 'verify_agreement_modal_view',
  /** EVT-26 协议文本弹窗关闭 — 公共参数 + agreementId + closeType（`close`/`mask`/`confirm`） */
  AGREEMENT_MODAL_CLOSE: 'verify_agreement_modal_close',
  /** EVT-27 二次确认弹窗曝光 — 公共参数 */
  AGREEMENT_RECONFIRM_VIEW: 'verify_agreement_reconfirm_view',
  /** EVT-28 二次确认弹窗"同意并继续" — 公共参数 */
  AGREEMENT_RECONFIRM_AGREE: 'verify_agreement_reconfirm_agree',
  /** EVT-29 二次确认弹窗"取消/再想想" — 公共参数 */
  AGREEMENT_RECONFIRM_CANCEL: 'verify_agreement_reconfirm_cancel',
  // endregion
};

ATTA_REPORT.SUBMIT_TIP = {
  SUBMITTED_REQ: 'act_submitrem_req', // 活动页_订购完成领取提醒弹窗_弹出
  SUBMITTING_REQ: 'act_submitting_req', // 活动页_订购中状态提醒弹窗_弹出
};

ATTA_REPORT.SUBMIT_SUCCESS = {
  REQ: 'act_submitcpl_req', // 弹窗展示
  CLICK: 'submitcpl_gifreq_click', // 点击取消
};

ATTA_REPORT.GAME_ROLE = {
  VIEW: 'act_selrolepop_req',
  FIND_SUCCESS: 'act_selrolesuccess_req',
  FIND_FAIL: 'act_selrolefail_req',
  CANCEL: 'selrolepop_cancel_click',
  CONFIRM: 'selrolepop_confirm_click',
};

// 移动领取限制
ATTA_REPORT.CMCC_RECEIVE_LIMIT = {
  RECEIVE_GUIDE_VIEW: 'act_getguidepop_req',
  RECEIVE_GUIDE_CONFIRM: 'getguidepop_get_click',
  RECEIVE_GUIDE_CLOSE: 'getguidepop_close_click',
  RECEIVE_GUIDE_DONE: 'getguidepop_got_click',
  FIXED_ENTRY_VIEW: 'act_fixedgetentry_view',
  FIXED_ENTRY_CLICK: 'act_fixedgetentry_click',
  RECEIVE_LOADING_VIEW: 'act_authguidepop_req',
  RECEIVE_LOADING_CLICK: 'authguidepop_auth_click',
};

ATTA_REPORT.ASYNC_DELIVER = {
  ASYNC_DELIVER_VIEW: 'act_autodeliverpop_req',
  ASYNC_DELIVER_AUTH_CLICK: 'autodeliverpop_auth_click',
  AYSNC_DELIVER_CLOSE_CLICK: 'autodeliverpop_close_click',
};

ATTA_REPORT.FREE_LOTTERY = {
  LOTTERY_CLICK: 'freelotpop_lot_click',
  LOTTERY_DIALOG_CLOSE: 'freelotpop_close_click',
  LOTTERY_DIALOG_VIEW: 'act_freelotpop_req',
  LOTTERY_BUBBLE_CLICK: 'act_freelotbub_click',
  LOTTERY_BUBBLE_VIEW: 'act_freelotbub_view',
  LOTTERY_RESULT_VIEW: 'act_freelotre_req',
  LOTTERY_RESULT_RECEIVE: 'freelotre_get_click',
  LOTTERY_RESULT_CLOSE: 'freelotre_close_click',
  LOTTERY_ROLE_VIEW: 'act_rolelistpop_req',
  LOTTERY_ROLE_CHANGE: 'rolelistpop_chgrole_click',
  LOTTERY_ROLE_CONFIRM: 'rolelistpop_confir_click',
  LOTTERY_ROLE_CLOSE: 'rolelistpop_close_click',
  LOTTERY_RECEIVE_VIEW: 'act_freelotgift_req',
  LOTTERY_RECEIVE_CLOSE: 'freelotgift_colse_click',
  LOTTERY_RECEIVE_CONTINUE: 'freelotgift_colse_click',
  LOTTERY_ORDER_VIEW: 'act_freelotorder_req',
  LOTTERY_ORDER_INPUT: 'freelotorder_telinput_finish',
  LOTTERY_ORDER_CLICK: 'freelotorder_orderbtn_click',
  LOTTERY_ORDER_CLOSE: 'freelotorder_close_click',
};

ATTA_REPORT.INVITE_SHARE = {
  INVITE_SHARE_ENTRY_VIEW: 'act_newgettab_view',
  INVITE_SHARE_ENTRY_CLICK: 'newgettab_join_click',
  INVITE_SHARE_JUMP: 'act_extwechat_skip',
};

ATTA_REPORT.EXCHANGE = {
  EXCHANGE_CLICK: 'act_exchange_click',
  EXCHANGE_CONFIRM_VIEW: 'act_excconfirmpop_req',
  EXCHANGE_CONFIRM_CLICK: 'excconfirmpop_confirm_click',
  EXCHANGE_CONFIRM_CLOSE: 'excconfirmpop_cancel_click',
  EXCHANGE_SUCCESS_VIEW: 'act_excsuccesspop_req',
  EXCHANGE_FAIL_VIEW: 'act_excfailpop_req',
};

ATTA_REPORT.MULTIPLE_LOTTERY = {
  PLACE_ORDER: 'act_lotbtn_order', // 十连抽按钮下单
  LOTTERY: 'act_lotbtn_lottery', // 十连抽按钮抽奖
  RECORD_BTN_CLICK: 'act_recordbtn_click', // 十连抽记录按钮展示
  LOTTERY_RESULTMODAL_VIEW: 'lot_resultmodal_show', // 十连抽结果展示
  LOTTERY_CARDFLIP_ANIMATION: 'lot_cardflip_animation', // 翻牌动画展示
  LOTTERY_REWARD_CLICK: 'lot_reward_click', // 点击已翻开的奖励icon
  LOTTERY_SHOW_ALL_REWARDS: 'lot_showallrewards_click', // 展示全部奖励
  LOTTERY_CLOSE_MODAL: 'lot_knownclose_modal', // 关闭弹窗
  LOTTERY_REDIRECT_TO_THIRD_PARTY: 'lot_redirecttolink_click', // 前往第三方地址
  LOTTERY_QB_RESULT: 'lot_qbaccept_res', // q币领取结果
  LOTTERY_FRAGMENT_VIEW: 'lot_fragmentdialog_show', // 碎片详情展示
};

ATTA_REPORT.QB_ACCEPT_MODAL = {
  SHOW: 'lot_qbacceptmodal_show', // q币领取登录弹窗展示
  CANCEL: 'lot_qbacceptmodal_cancel', // q币领取登录弹窗关闭
  CONFIRM: 'lot_qbacceptmodal_confirm', // q币领取登录弹窗确认
};

ATTA_REPORT.QQ_LOGIN = {
  RESULT: 'act_qqlogin_res', // qq登录结果
};

ATTA_REPORT.USER_LOTTERY = {
  LOTTERY_CLOSE_MODAL: 'lot_knownclose_modal', // 关闭弹窗
};

ATTA_REPORT.AWARD_DIALOG = {
  DEBRIS_SHOW: 'lot_debrisawarddialog_show', // 碎片奖励弹窗展示
  DEBRIS_CLICK: 'lot_debrisawarddialog_click', // 碎片奖励弹窗点击订购按钮
  SHOW: 'lot_awarddialog_show', // 非碎片奖励弹窗展示
  CLICK: 'lot_awarddialog_click', // 非碎片奖励弹窗点击订购按钮
};

ATTA_REPORT.USED_DEBRIS_LIST = {
  SHOW: 'lot_useddebrislist_show', // 碎片消耗列表展示
};
ATTA_REPORT.USER_REWARD = {
  MYREWARD_NOTRECEIVED_CLICK: 'myreward_prizenotreceived_click',
  MYREWARD_RECEIVED_CLICK: 'myreward_prizereceived_click',
  MYREWARD_REWARD_SHOW: 'myreward_rewardtab_show',
  MYREWARD_FRAGMENTTAB_SHOW: 'myreward_fragmenttab_show',
  MYREWARD_FRAGMENT_CLICK: 'myreward_fragmenttab_prizeclick',
};

ATTA_REPORT.LOTTERY_REACEIVE = {
  AMS_RECEIVE_FAIL: 'amsreceive_faildialog_show',
  AMS_RECEIVE_SUCCESS: 'amsreceive_successdialog_show',
  GOODS_RECEIVEDIALOG_SHOW: 'goodsreceive_addressdialog_show',
  SAVE_ADDRESS_SUCCESS: 'goodsreceive_addressssave_success',
  SAVE_ADDRESS_FAIL: 'goodsreceive_addressssave_fail',
};

ATTA_REPORT.RECEIVE_FREE_GIFT = {
  SMS_CODE: 'freegift_smscode_req',
  RECEIVE_BUTTON_CLICK: 'freegift_receivebtn_click',
  RECEIVE_FAIL: 'freegift_receive_fail',
  RECEIVE_SUCCESS: 'freegift_receive_success',
  MORE_WELFARE_BUTTON_CLICK: 'freegift_morewelfarebtn_click',
  GO_ACTIVE_PAGE_BUTTON_CLICK: 'freegift_goactivepagebtn_click',
  TIPS_SHOW: 'freegift_tips_show',
  TIPS_CLICK: 'freegift_tips_click',
  TIPS_FREE_LOTTERY: 'freegift_tips_freelottery',
  ACTIVE_BUTTON_SHOW: 'freegift_activebtn_show',
  ACTIVE_BUTTON_CLICK: 'freegift_activebtn_click',
  RECEIVE_FAIL_TIPS: 'freegift_receivefail_tips',
  RECEIVE_FAIL_TIPS_CLICK: 'freegift_receivefail_tipsclick',
  HAS_RECEIVED_TIPS: 'freegift_hasreceived_tips',
  HAS_RECEIVED_TIPS_CLICK: 'freegift_hasreceived_tipsclick',
  // 引导订购
  GUIDE_ORDER_SHOW: 'freegift_guideorder_click',
  // 手机号二次确认弹窗-曝光
  PHONE_CONFIRM_SHOW: 'freegift_phoneconfirm_show',
  // 手机号二次确认弹窗-点击确认
  PHONE_CONFIRM_CLICK: 'freegift_phoneconfirm_click',
  // 成功弹窗
  DIALOG_ORDER_CLICK: 'freegift_order_click',
  DIALOG_ACTIVE_CLICK: 'freegift_active_click',
  // 失败弹窗
};

ATTA_REPORT.SIGN_IN = {
  SIGN_AREA_CLICK: 'sign_area_click',
  MOBILE_INPUT_DIALOG: 'sign_mobilepop_view',
  MOBILE_INPUT_DIALOG_CONFIRM: 'sign_mobilepop_confirm',
  SIGN_FLOAT_VIEW: 'sign_float_view',
  SIGN_BUTTON_CLICK: 'sign_btn_click',
  GO_TO_LOTTERY: 'sign_lottery_click',
  MY_REWARD_CLICK: 'sign_myreward_click',
  TOURISTS_REWARD_DIALOG_SHOW: 'sign_touristsreward_show',
  TOURISTS_REWARD_DIALOG_BUTTON_CLICK: 'sign_touristsrewarddialogbtn_click',
  MEMEBER_REWARD_DIALOG_SHOW: 'sign_memberreward_show',
  MEMBER_REWARD_DIALOG_BUTTON_CLICK: 'sign_memberrewarddialogbtn_click',
  ACCUMULATED_REWARD_TIPS_SHOW: 'sign_accumulatedrewardtips_show',
};

ATTA_REPORT.FLOAT = {
  RULE_SHOW: 'float_rule_show',
};

ATTA_REPORT.FESTIVAL_LOTTERY = {
  LOTTERY_AREA_CLICK: 'festivallottery_area_click',
  LOTTERY_MOBILE_INPUT_DIALOG: 'festivallottery_mobilepop_view',
  LOTTERY_MOBILE_INPUT_DIALOG_CONFIRM: 'festivallottery_mobilepop_confirm',
  LOTTERY_FLOAT_VIEW: 'festivallottery_float_view',
  TOURISTS_FLOAT_LOTTERY_BUTTON_CLICK: 'festivallottery_touristfloatbtn_click',
  MEMBER_FLOAT_LOTTERY_BUTTON_CLICK: 'festivallottery_memberfloatbtn_click',
  NO_LOTTERY_CHANCE: 'festivallottery_nolottery_chance',
  NO_LOTTERY_CHANCE_ORDER_CLICK: 'festivallottery_nochancedialogbtn_click',
  LOTTERY_DIALOG_SHOW: 'festivallottery_dialog_show',
  LOTTERY_BUTTON_CLICK: 'festivallottery_dialogbtn_click',
  TOURISTS_REWARD_DIALOG_SHOW: 'festivallottery_touristsreward_show',
  TOURISTS_REWARD_DIALOG_BUTTON_CLICK: 'festivallottery_touristsrewarddialogbtn_click',
  MEMEBER_REWARD_DIALOG_SHOW: 'festivallottery_memberreward_show',
  MEMBER_REWARD_DIALOG_BUTTON_CLICK: 'festivallottery_memberrewarddialogbtn_click',
};

ATTA_REPORT.CASH = {
  QQ_DIALOG_SHOW: 'cash_qqdialog_show',
  QQ_DIALOG_CONFIRM: 'cash_qqdialog_confirm',
  QQ_VALIDATE_FAIL: 'cash_qqvalidate_fail',
  QQ_CONFIRM_DIALOG_SHOW: 'cash_qqconfirmdialog_show',
  QQ_CONFIRM_DIALOG_CONFIRM: 'cash_qqconfirmdialog_confirm',
  RECEIVE_SUCCESS_DIALOG_SHOW: 'cash_receivesuccessdialog_show',
  RECEIVE_FAIL_DIALOG_SHOW: 'cash_receivefaildialog_show',
};

ATTA_REPORT.YZF = {
  ORDERING_POP_VIEW: 'act_orderingpop_view',
  ORDER_FAIL_POP_VIEW: 'act_orderfailpop_view',
  CODE_EXPIRED_POP_VIEW: 'act_codeexpiredpop_view',
  ORDER_SUBMITTED_POP_VIEW: 'act_ordersubmittedpop_view',
  ORDER_CACHE_QUERY: 'act_ordercache_query',
};

ATTA_REPORT.ORDER_RETAIN = {
  RETAIN_ORDER_PV: 'retain_order_view',
  RETAIN_ORDER_CLICK: 'retain_order_click',
  RETAIN_BACK_CLICK: 'retain_back_click',
};

ATTA_REPORT.UNSUPPORTED_MODAL = {
  GIFT_MODAL_SHOW: 'unsupportedgift_modal_show',
  NOGIFT_MODAL_SHOW: 'unsupportednogift_modal_show',
  RESULT_MODAL_SHOW: 'unsupportedresult_modal_show',
};

ATTA_REPORT.GAME_CARD_GUIDE = {
  CLICK: 'guide_click',
};

ATTA_REPORT.POPUP = {
  CONFIRM_CLICK: 'act_popup_click',
  PV: 'act_popup_view',
};

ATTA_REPORT.LIMIT_ACTIVITY = {
  RECEIVE_CLICK: 'renewal_receiveButton_click',
};

// 多命名空间的方式无法快速找到定义
const ATTA_LIMITED_TIME_ACT = {
  ORDER: 'limitedtime_button_click',
};

const ATTA_QB_DIALOG = {
  SHOW: 'qbaccept_modal_show', // q币领取登录弹窗展示
  CONFIRM: 'qbaccept_modal_confirm', // q币领取登录弹窗确认
  ACCEPT_SUCCESS: 'qbaccept_success_show', // q币领取成功
  ACCEPT_FAIL: 'qbaccept_fail_show', // q币领取失败
};

const ATTA_CDKEY_DIALOG = {
  SHOW: 'cdkey_dialog_show', // cdkey弹窗展示
  COPY: 'cdkey_dialog_copy', // cdkey弹窗复制
};

export const ATTA_JUMP_TO_SURVEY = {
  /** 跳转至问卷按钮点击 */
  CLICK: 'jump2survey_button_click',
};

const ATTA_GATEWAY_MOBILE = {
  RESET_CLICK: 'gatewaymobile_reset_click',
  MASK_MOBILE_RESULT: 'gatewaymobile_maskmobile_fetch',
  MOBILE_TOKEN_RESULT: 'gatewaymobile_mobiletoken_fetch',
  IC_MOBILE_RESULT: 'icauth_mobile_fetch',
  AGREEMENT_TOGGLE: 'gatewaymobile_agreement_toggle',
  AGREEMENT_CONFIRM: 'gatewaymobile_agreement_confirm',
  AGREEMENT_VIEW: 'gatewaymobile_agreement_view',
};

export {
  ATTA_REPORT,
  ATTA_EVENT_RESULT,
  ATTA_LIMITED_TIME_ACT,
  ATTA_QB_DIALOG,
  ATTA_CDKEY_DIALOG,
  ATTA_GATEWAY_MOBILE,
};
